import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './globals.css';
import ErrorBoundary from './components/ErrorBoundary';

/**
 * Mbrojtje shtesë për gabimet e mjedisit në JavaScript.
 */
window.addEventListener('error', (event) => {
  const msg = event.message || "";
  if (msg.includes('window host') || msg.includes('location.host')) {
    event.preventDefault();
  }
}, true);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
